export default __webpack_public_path__ + "static/media/Version (5) - Deathly Hallows_21.a627f34b.jpg";